<template>
  <div class="payment-choice" role="dialog" aria-modal="true" aria-labelledby="payment-choice-title" tabindex="-1" @click.self="cancelSelection" @keydown.esc.prevent="cancelSelection">
    <div class="payment-choice-panel">
      <h2 id="payment-choice-title">选择支付方式</h2>
      <fieldset class="payment-methods" role="radiogroup" aria-label="支付方式" :disabled="submitting" @keydown.left.prevent="moveSelection(-1)" @keydown.up.prevent="moveSelection(-1)" @keydown.right.prevent="moveSelection(1)" @keydown.down.prevent="moveSelection(1)">
        <legend class="visually-hidden">支付方式</legend>
        <button v-for="method in paymentMethods" :key="method.value" type="button" class="payment-method" :class="{ 'is-selected': selectedMethod === method.value }" role="radio" :aria-checked="selectedMethod === method.value" :tabindex="selectedMethod === method.value ? 0 : -1" @click="selectMethod(method.value)">
          <img class="payment-method-icon" :src="method.icon" alt="">
          <span class="payment-method-name">{{ method.label }}</span>
          <img class="payment-method-check" :src="selectedMethod === method.value ? selectedIcon : unselectedIcon" alt="">
        </button>
      </fieldset>
      <p v-if="selectedMethod === 'ALIPAY'" class="payment-hint">支付宝支付需保存二维码，在支付宝扫一扫中选择相册图片。</p>
      <button type="button" class="confirm" :disabled="submitting" @click="confirmSelection">确认支付</button>
    </div>
  </div>
</template>

<script>
import wechatIcon from '@/assets/images/payment/weixin.png'
import alipayIcon from '@/assets/images/payment/zhifubao.png'
import selectedIcon from '@/assets/images/payment/icon_check.png'
import unselectedIcon from '@/assets/images/payment/icon_check_normal.png'

export default {
  name: 'FuxunPaymentChoice',
  data() {
    return {
      selectedMethod: 'WECHATPAY',
      submitting: false,
      selectedIcon,
      unselectedIcon,
      paymentMethods: [
        { value: 'WECHATPAY', label: '微信支付', icon: wechatIcon },
        { value: 'ALIPAY', label: '支付宝支付', icon: alipayIcon }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => this.$el.focus())
  },
  methods: {
    selectMethod(method) {
      if (!this.submitting) this.selectedMethod = method
    },
    moveSelection(direction) {
      if (this.submitting) return
      const index = this.paymentMethods.findIndex(method => method.value === this.selectedMethod)
      const nextIndex = (index + direction + this.paymentMethods.length) % this.paymentMethods.length
      this.selectMethod(this.paymentMethods[nextIndex].value)
      this.$nextTick(() => this.$el.querySelector('[role="radio"][aria-checked="true"]').focus())
    },
    confirmSelection() {
      this.finishSelection(this.selectedMethod)
    },
    cancelSelection() {
      this.finishSelection(null)
    },
    finishSelection(method) {
      if (this.submitting) return
      this.submitting = true
      this.$emit('select', method)
    }
  }
}
</script>

<style lang="less" scoped>
.payment-choice {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px 20px 40px;
  padding-bottom: calc(40px + env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, .45);

  .payment-choice-panel {
    box-sizing: border-box;
    width: 710px;
    max-width: 100%;
    max-height: 100%;
    overflow-y: auto;
    padding: 30px 20px;
    border: 1px solid #0087ff;
    border-radius: 16px;
    background: #fff;
    color: #646464;
  }

  h2 {
    margin: 0 0 30px;
    font-family: inherit;
    font-size: 36px;
    font-weight: normal;
    line-height: 60px;
    text-align: center;
  }

  .payment-methods {
    margin: 0;
    padding: 0;
    border: 0;
    min-width: 0;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
  }

  .payment-method {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    min-height: 112px;
    margin-bottom: 24px;
    padding: 22px 24px;
    border: 2px solid #e1d8cd;
    border-radius: 16px;
    background: #fff;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .payment-method.is-selected {
    border-color: #a1805d;
    background: #fbf6ef;
    color: #8f6c46;
  }

  .payment-method > * {
    pointer-events: none;
  }

  .payment-method-icon {
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }

  .payment-method-name {
    flex: 1;
    font-size: 28px;
    line-height: 40px;
  }

  .payment-method-check {
    width: 44px;
    height: 44px;
    margin-left: 20px;
  }

  .payment-hint {
    margin: -10px 0 20px;
    font-size: 24px;
    line-height: 36px;
    color: #666;
  }

  button {
    display: block;
    width: 100%;
    border: 0;
    font-family: inherit;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid #0087ff;
    outline-offset: 4px;
  }

  .confirm {
    min-height: 88px;
    padding: 16px;
    border-radius: 16px;
    background: #a1805d;
    color: #fff;
    font-size: 36px;
    line-height: 54px;
  }

}
</style>
